import { render, staticRenderFns } from "./LogoModal.vue?vue&type=template&id=6014be0d&"
import script from "./LogoModal.vue?vue&type=script&lang=js&"
export * from "./LogoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports